import axios from "@/utils/api-v1"

export default {
  createProfile(userId, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/company/profile`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.response.data) {
            reject(error.response.data)
          } else {
            reject(error.message)
          }
        })
    })
  },
  async getProfile(profileId) {
    return await axios.get(`/api/company/profile/${profileId}`)
  },
  async getRequestedProfiles() {
    return await axios.get(`/api/company/profile/access/requested`)
  },
  async getGrantedProfiles() {
    return await axios.get(`/api/company/profile/access/granted`)
  },
  async getRejectedProfiles() {
    return await axios.get(`/api/company/profile/access/rejected`)
  },
  checkUserProfileExists(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/company/profile/check/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.response.data) {
            reject(error.response.data)
          } else {
            reject(error.message)
          }
        })
    })
  },
  async getProfileCompleted(profileId) {
    return await axios.get(`/api/company/profile/completed/${profileId}`)
  },
  async getUserProfile(userId) {
    return await axios.get(`/api/company/profile/user/${userId}`)
  },
  async applyForProject(projectProfileId, profileId, projectId) {
    return await axios.patch(
      `/api/company/profile/access/request/${projectProfileId}`,
      { profile: profileId, project: projectId, type: "project" }
    )
  },
  async requestProfileAccess(recipientProfileId, id, type) {
    let body = { type }
    if (type == "project") {
      body.project = id
    } else if (type == "job" || type == "job-application") {
      body.job = id
    }
    return await axios.patch(
      `/api/company/profile/access/request/${recipientProfileId}`,
      body
    )
  },
  async grantProfileAccess(recipientProfileId, id, type) {
    let body = { type }
    if (type == "project") {
      body.project = id
    } else if (type == "job" || type == "job-application") {
      body.job = id
    }
    return await axios.patch(
      `/api/company/profile/access/grant/${recipientProfileId}`,
      body
    )
  },
  async grantProject(projectProfileId, profileId, projectId) {
    return await axios.patch(
      `/api/company/profile/access/grant/${projectProfileId}`,
      {
        profile: profileId,
        project: projectId,
        type: "project",
      }
    )
  },
  async rejectProfileAccess(recipientProfileId, id, type, reason) {
    let body = { type, reason }
    if (type == "project") {
      body.project = id
    } else if (type == "job" || type == "job-application") {
      body.job = id
    }
    return await axios.patch(
      `/api/company/profile/access/reject/${recipientProfileId}`,
      body
    )
  },
  async sendSupport(profileId, data) {
    return await axios.post(`/api/company/profile/support/`, {
      profileId,
      data,
    })
  },
  updateProfile(profileId, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/company/profile/${profileId}`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.response.data) {
            reject(error.response.data)
          } else {
            reject(error.message)
          }
        })
    })
  },
  findUsers(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/company/find-users-within-radius`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.response.data) {
            reject(error.response.data)
          } else {
            reject(error.message)
          }
        })
    })
  },
  searchUsersByParams(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/company/profile/search`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log("error", error)
          if (error.response.data) {
            reject(error.response.data)
          } else {
            reject(error.message)
          }
        })
    })
  },
  sendJobBriefing(company, jobBriefing, userId) {
    return axios.post("/api/profile/" + userId + "/briefing", {
      company,
      jobBriefing,
      userId,
    })
  },
  getCompanies(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/company/admin/companies`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log("error", error)
          if (error.response.data) {
            reject(error.response.data)
          } else {
            reject(error.message)
          }
        })
    })
  },
  deleteCompany(companyId) {
    return axios.patch(`/api/company/profile/delete/${companyId}`)
  },
  async getCompanyMatches(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/company/matches`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log("error", error)
          if (error.response.data) {
            reject(error.response.data)
          } else {
            reject(error.message)
          }
        })
    })
  },

  async removeCompanyMatch(jobseekerId) {
    return await axios.post(`/api/company/remove-matches`, jobseekerId)
  },
  async getSuccessCenterItems(id) {
    return await axios.get(`/api/company/${id}/success-center-items`)
  },
  async getStats() {
    return await axios.get(`/api/company/get-stats`)
  },
  async getActivities() {
    return await axios.get(`/api/company/get-activities`)
  },
  async getDeclined(id) {
    return await axios.get(`/api/company/${id}/declined`)
  },
  async getCompanyBenefitsList() {
    return await axios.get(`/api/benefits/list`)
  },
  async getCompanyUsers(id) {
    return await axios.get(`/api/users/company/${id}`)
  },
  async addCompanyUser(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/users/company-user`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.log("error", error)
          if (error.response.data) {
            reject(error.response.data)
          } else {
            reject(error.message)
          }
        })
    })
  },
  async editCompanyUser(userId, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/users/company-user/${userId}`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.response.data) {
            reject(error.response.data)
          } else {
            reject(error.message)
          }
        })
    })
  },
  async onboardCompanies(rows) {
    return await axios.post("/api/admin/onboard-companies", { rows })
  },
  async reinstateCompanyUser(userId, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/users/company-user/${userId}/reinstate`, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.response.data) {
            reject(error.response.data)
          } else {
            reject(error.message)
          }
        })
    })
  },
}
